import PropTypes from 'prop-types'
import BaseLayout from '@components/layouts/Base'
import { useEffect } from 'react'
import { setLanguage as setI18nLang } from '@lang'
import {
  LANG_DE,
  LANG_EN,
  ROUTE_SELECT,
  ROUTE_SHOWMOCK,
  ROUTE_UPLOAD,
} from '@config/constants'
import { useDispatch } from 'react-redux'
import { actionSetLanguage as setLanguageAction } from '@store/reducers/app'

import { MemoryRouter, Routes, Route } from 'react-router-dom'
import StepSelect from '@components/organisms/pages/StepSelect/StepSelect'
import StepUpload from '@components/organisms/pages/StepUpload/StepUpload'
import StepShowMockup from '@components/organisms/pages/StepShowMockup/StepShowMockup'

const App = ({ lang }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    setI18nLang(lang)
    dispatch(setLanguageAction(lang))
  }, [false])

  return (
    <BaseLayout>
      <MemoryRouter initialEntries={[ROUTE_SELECT]}>
        <Routes>
          <Route path={ROUTE_SELECT} element={<StepSelect />} />
          <Route path={ROUTE_UPLOAD} element={<StepUpload />} />
          <Route path={ROUTE_SHOWMOCK} element={<StepShowMockup />} />
        </Routes>
      </MemoryRouter>
    </BaseLayout>
  )
}

App.defaultProps = {
  lang: LANG_DE,
}
App.propTypes = {
  lang: PropTypes.oneOf([LANG_DE, LANG_EN]),
}

export default App
